
const context = require.context('components', true, /_component\.js$/);
context.keys().forEach(context);
// document.addEventListener("turbolinks:load", () => {
// 	const file = 'components/' + document.querySelector("body").dataset.controller + '_component.js';
// 	console.log(file)
// 	import('components/inventory_movements_component.js'); 
// })